import type { Ref } from "react";
import { Input, type InputRef } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

interface QuantityStepperProps {
  quantity: number;
  quantityInput: string;
  onInputChange: (value: string) => void;
  onDecrement: () => void;
  onIncrement: () => void;
  isMobile: boolean;
  autoFocus?: boolean;
  inputRef?: Ref<InputRef>;
  onPressEnter?: () => void;
  // Таван на бройката (порциите от дневно меню) — „+" е заключен на него
  maxQuantity?: number;
}

/** Голям степер за количество с редактируем четец по средата. */
export const QuantityStepper = ({
  quantity,
  quantityInput,
  onInputChange,
  onDecrement,
  onIncrement,
  isMobile,
  autoFocus,
  inputRef,
  onPressEnter,
  maxQuantity = Infinity,
}: QuantityStepperProps) => (
  <div className="flex items-center justify-center gap-4">
    <BigStepBtn
      glyph="−"
      onClick={onDecrement}
      disabled={quantity <= 1}
      isMobile={isMobile}
    />
    <Input
      ref={inputRef}
      value={quantityInput}
      onChange={(e) => onInputChange(e.target.value)}
      onPressEnter={
        onPressEnter &&
        ((e) => {
          e.preventDefault();
          onPressEnter();
        })
      }
      className={`!rounded-[15px] !border-pos-line3 !bg-pos-card !text-center !font-pos-mono !text-[26px] !font-bold !text-pos-ink ${
        // Побира „0.500" на едрия моно шрифт, без да се реже
        isMobile ? "!h-[54px] !w-[108px]" : "!h-[60px] !w-[124px]"
      }`}
      placeholder="1"
      autoFocus={autoFocus}
    />
    <BigStepBtn glyph="+" onClick={onIncrement} disabled={quantity >= maxQuantity} isMobile={isMobile} />
  </div>
);

// Голям −/+ бутон на степера за количество (60×60, на телефон 54×54).
// Иконите са antd SVG — текстовите глифи висят под центъра (baseline).
const BigStepBtn = ({
  glyph,
  onClick,
  disabled,
  isMobile,
}: {
  glyph: "−" | "+";
  onClick: () => void;
  disabled?: boolean;
  isMobile: boolean;
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`grid flex-shrink-0 cursor-pointer place-items-center rounded-[15px] border border-pos-ctl bg-pos-stepper transition-colors disabled:cursor-not-allowed disabled:opacity-40 ${
      isMobile ? "h-[54px] w-[54px]" : "h-[60px] w-[60px]"
    } ${glyph === "−" ? "text-pos-dim" : "text-pos-accent-ink"}`}
  >
    {glyph === "−" ? (
      <MinusOutlined className="text-[20px]" />
    ) : (
      <PlusOutlined className="text-[20px]" />
    )}
  </button>
);
